import React from 'react';
import classNames from 'classnames';
import { NextLink } from 'components/blocks/NextLink';
import styles from 'components/common/FeaturedCamera/CameraViewTitle.module.scss';

interface ICameraViewTitleProps {
  href?: string
  title?: string
  date?: string
  isResortCams?: boolean
}
const CameraViewTitle = ({
  href, title, date, isResortCams,
}: ICameraViewTitleProps) => {
  const baseClass = classNames(styles.title, isResortCams ? styles.resortCam : undefined);
  const children = isResortCams ? (
    <>
      {title && <span className={styles.resortCamTitle}>{title}</span>}
      {date && <span className={styles.resortCamDate}>{date}</span>}
    </>
  ) : (
    <>
      <span>{title}</span>
      {date && (<span>{date}</span>)}
    </>
  );

  if (href) {
    return (
      <NextLink className={baseClass} href={href}>
        {children}
      </NextLink>
    );
  }

  return (
    <div className={baseClass}>
      {children}
    </div>
  );
};

export default CameraViewTitle;
